import { IPublicClientApplication } from "@azure/msal-browser";
import {
  UnauthenticatedTemplate,
  useIsAuthenticated,
  useMsal,
} from "@azure/msal-react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import "./login.scss";
import { authorize } from "../api/Auth/authorization";
import { useUser } from "../contexts/userContextApi";

const Login: React.FC<any> = () => {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const { setIsAuthorize, setIsLoadingLandingPage, setRole } = useUser();
  /**
   * Call backend authorization API using Azure AD ID token
   */
  const fetchAuthToken = async (idToken: string) => {
    try {
      setIsLoadingLandingPage(true);
      //const idTokens='eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6ImRndlNEdks4QTVLeUt5cHB3MWRBd1RYRDNDQSJ9.eyJhdWQiOiI5ZTBiZDdkNy04YmU0LTRlNzMtYWQ5OS04MWMyN2YzMTA4YjYiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vZWE4MDk1MmUtYTQ3Ni00MmQ0LWFhZjQtNTQ1Nzg1MmIwZjdlL3YyLjAiLCJpYXQiOjE3OTA2MDAwNjUsIm5iZiI6MTc5MDYwMDA2NSwiZXhwIjoxNzkwNjAzOTY1LCJhaW8iOiJBY1FBTy84ZUFBQUE4WUxYZ2xqd1NjSEpjakllc1FvL2lZcDVjNitvUDlLNFZHRjZxQXBuenp6WGdEcndFS0RPT3YzZUpGMk1GZjk4RTgzMHJZdmtIYVRUZGluWDZwVmh3aERHRVowdG8xYnJNa1A5RWJiMmxHZmRaYlpCbVQvTXRydGduK0tmS2F4TXhpMWRnTnJnWlY0WVk4QmhTU2VJOFdPOHJaMDQyOHdoSXpYcjNvYmlnSG9TSXdXYVVvSDlYVGVJQllqUVJWaGMyN2prRFFuYjFSU3BRVzZJL3JNTGNLY0FlSGRzMWg1bnJVeElnZ0M1LzdkVlVhTHU1VEFwYVd0eUYxeHgwR2FYIiwibmFtZSI6IlN1Z2l1cmEsIEF0c3VzaGkiLCJub25jZSI6IjAxYTBlODE5LTI2N2YtNzFjZi1hZjY2LTMxNTZjMWYwNjJmNSIsIm9pZCI6ImE0ZTgxZDNkLWQ5MjUtNDYyMy1iMTNkLWY4YTAzYmZjNWQ3MiIsInByZWZlcnJlZF91c2VybmFtZSI6ImF0c3VzaGkuc3VnaXVyYUBjYXN0cm9sLmNvbSIsInJoIjoiMS5BUWtBTHBXQTZuYWsxRUtxOUZSWGhTc1BmdGZYQzU3a2kzTk9yWm1Cd244eENMWUpBQTRKQUEuIiwicm9sZXMiOlsiR01FREhQUk9EVVNFUkxJU1RAY2FzdHJvbC5jb20iXSwic2lkIjoiMDA3ZWQ0ZGEtYTc2MC1hMjYzLTFmOTMtN2QzMmRhYjY4ZmI0Iiwic3ViIjoicVJnZXphUl85WHUybUxhMHlwTENSbzRKTGR1Q0JhN0V3aDduYkY2UmVNVSIsInRpZCI6ImVhODA5NTJlLWE0NzYtNDJkNC1hYWY0LTU0NTc4NTJiMGY3ZSIsInV0aSI6IkdZdlJfT1VCYUVXYXhsQ3dHemwwQUEiLCJ2ZXIiOiIyLjAiLCJOVElEIjoic3VhaDZwIn0.mGVdNWxjk9gJwHps2iElOjomo8fjrhK-VaspyXzz_YHJ77qZST-U9E1WW8E5uBTJYUIdaTh3Q0yaxuinmjajJ_t-G3hCzGGT0xwdwFkgl6SN4au5fVPLZlOUsN9SQRyuQVaZMHh1vDtoCjBGmnO9R4sZjsFxh1wMs_BwyOrUgUJE_7oHn8EUeEdoAzkVRdzm9YJyYrLUi_Oq60oVdXCGG-1LdYmxh4Pa84LIvLF9chyXGUJclQmgGq17FWUaloqBCAn57oNvD5lwvXoEpmDZijHCNlRHn2OXZ-fLQ3Pjbi8_he3fQqwnalQIhsvkaAsiARJ9wngXqgra1bCO7wBYZg'
      const res: any = await authorize(idToken);
      if(res.statusCode === 401){
        console.log("User is not authorized to access this resource with an explicit deny");
        // sessionStorage.setItem("isUnAuth", "false");
        // setIsAuthorize(false);
        return "User is not authorized to access this resource with an explicit deny"
        
      }
      else{
      sessionStorage.setItem("jwt", res.jwtToken);

      const role = res.role;
      sessionStorage.setItem("role", role);
      setRole(role);

      sessionStorage.setItem(
        "tokenExpireTime",
        res.tokenExpireTime
      );

      return res;
    }
    } finally {
      setIsLoadingLandingPage(false);
    }
  };

  /**
   * Get latest ID token from MSAL
   */
  const getIdTokenAndAuthorize = async () => {
    if (!accounts || accounts.length === 0) {
      console.log("No MSAL account found");
      return;
    }

    try {
      const account = accounts[0];

      /**
       * Get a fresh/cached token through MSAL.
       *
       * This is preferable to directly reading account.idToken.
       */
      const tokenResponse = await instance.acquireTokenSilent({
        account,
        scopes: ["User.Read"],
      });

      /**
       * accessToken is NOT the ID token.
       *
       * If your backend expects the Azure AD ID token,
       * use account.idToken.
       */
      console.log("Access token obtained from MSAL",tokenResponse);
      const idToken = tokenResponse.idToken || account.idToken;

      if (!idToken) {
        console.error("ID token not available");
        return;
      }

      console.log("ID token obtained from MSAL");

      const uid = account.idTokenClaims?.oid;

      if (uid) {
        sessionStorage.setItem("uuid", uid);
      }

      /**
       * Call your backend with ID token
       */
      const res = await fetchAuthToken(idToken);

      if (
        res ===
        "User is not authorized to access this resource with an explicit deny"
      ) {
        sessionStorage.setItem("isUnAuth", "false");
        setIsAuthorize(false);

        navigate("/UnAuthorize");
      } else {
        sessionStorage.setItem("isUnAuth", "true");
        setIsAuthorize(true);

        navigate("/drn");
      }
    } catch (error: any) {
      console.error("Authentication failed:", error);

      /**
       * If silent token acquisition fails because
       * interaction is required, redirect to login.
       */
      if (
        error?.name === "InteractionRequiredAuthError"
      ) {
        await instance.loginRedirect({
          scopes: ["User.Read"],
          state: "https://gmedocumenthub.castrol.com",
        });
      }
    }
  };

  /**
   * Handle authenticated user
   */
  useEffect(() => {
    if (!isAuthenticated || accounts.length === 0) {
      return;
    }

    console.log(
      "User authenticated. Getting ID token..."
    );

    getIdTokenAndAuthorize();

  }, [isAuthenticated, accounts]);
useEffect(() => {
    document.body.style.overflow = "hidden";
  
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  const redirectSignIn = async (instance: IPublicClientApplication) => {
    await instance.handleRedirectPromise();
    await instance.loginRedirect({
      scopes: ["User.Read"],
      state: "https://gmedocumenthub.castrol.com",
    });
  };
  const redirectSignOut = (instance: IPublicClientApplication) => {
    sessionStorage.clear();
    const logoutRequest = {
      postLogoutRedirectUri: `https://dtztk57qeqd06.cloudfront.net/`,
    };

    instance.logoutRedirect(logoutRequest);
  };

  return (
    <div className="loginPage">
    <UnauthenticatedTemplate>
      {/* <div className="loginContainer">
        <div className="signInSection">
          <div className="signInContainer">
            <span className="welcomeTitle">Sign In Here</span>
            <span className="intro">GME Document Hub</span>
            <Button
              className="signInButton"
              onClick={() => redirectSignIn(instance)}
            >
              Sign in
            </Button>
          </div>
        </div>
        <div className="landingContainer d-flex">
          <img
            src="./images/CastrolLogin.png"
            alt="Login Image"
            style={{ width: "inherit" }}
          />
        </div>
      </div> */}
      <div className="wrapper">
        <div className="login-container d-flex justify-content-between flex-column">
          <div>
          <h1 className="text-default wlc-txt">Welcome to GME Document Hub</h1>
          <div className="login-form-container">
            <div className="login-form-content">
              <div className="login-buttons">
                <div className="login-button">
                  <Button
                    className="signInButton"
                    style={{fontWeight: "500"}}
                    onClick={() => redirectSignIn(instance)}
                  >
                    bp staff enter here
                  </Button>
                </div>
              </div>
            </div>
          </div></div>
          {/* <div className="login-page-info-con" style={{  
  left: "initial", fontSize:"10px !importent",color:"red"
}} >
            <h1 className="display-6 fw-normal text-default" style={{marginTop:"1.5rem"}}>
            Access guide for GME Document Hub <a target="_blank" href="https://bp365.sharepoint.com/:b:/s/SynergyReplacement/Eer6Z913pfJCqavM3YLDvroB9qH3MkBblpqAz12tYdD1hQ?e=tB0bGO" className="text-brand-primary"> Click here.</a>
            </h1>
            <h1 className="display-6 fw-normal text-default">
            Send delivery and tax related documents to <a className="text-brand-primary" href="mailto:synergydrn@uk.bp.com" onClick={()=> window.location.href = 'mailto:synergydrn@uk.bp.com'}>synergydrn@uk.bp.com</a> mailbox.
            </h1>
            <h1 className="display-6 fw-normal text-default" style={{marginTop:"1.5rem"}}>
            Raise IT tickets for technical issues – <a target="_blank" href="https://eur03.safelinks.protection.outlook.com/?url=https%3A%2F%2Fmyit.bpglobal.com%2Fmyit%3Fid%3Dmyit_ticket_submission_form&data=05%7C02%7Canwar.shaik%40bp.com%7Cd0a67bf43c5d45f2214f08dc99d91ecf%7Cea80952ea47642d4aaf45457852b0f7e%7C0%7C0%7C638554405066380958%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=NRox%2BAp0Zg6%2F8WHyEAhJzZ4t4F%2Fs%2FlB5rdkOgIpXII4%3D&reserved=0" className="text-brand-primary">MyIT.</a>
            </h1>
            <h1 className="display-6 fw-normal text-default">
            Contact GME Document Hub Team at <a className="text-brand-primary" href="mailto:gmedochubsupport@castrol.com" onClick={()=> window.location.href = 'mailto:gmedochubsupport@castrol.com'}>gmedochubsupport@castrol.com</a>.</h1>
          </div> */}
          <div
  className="login-page-info-con"
  style={{ left: "initial", fontSize: "15px"}}
>
  <p style={{ marginTop: "0.5rem" }}>
    Access guide for GME Document Hub{" "}
    <a
      target="_blank"
      href="https://bp365.sharepoint.com/sites/gmedochub27/Shared%20Documents/Forms/AllItems.aspx?viewid=c2e544fe%2D8a5e%2D43f5%2Db89a%2Dfa6860879ccb&sharingv2=true&fromShare=true&at=9&CT=1780662674776&OR=OWA%2DNT%2DMail&CID=fc82f2d1%2D6298%2Dc4dd%2De3ec%2D1b44684599dd&SI=NonSentItems&clickParams=eyJYLUFwcE5hbWUiOiJNaWNyb3NvZnQgT3V0bG9vayBXZWIgQXBwIiwiWC1BcHBWZXJzaW9uIjoiMjAyNjA1MjkwMTQuMTEiLCJPUyI6Ik1hYyBPUyBYIHVuZGVmaW5lZCJ9&cidOR=Client&FolderCTID=0x012000728FF72D79EC0342A99C23A366C65FB8&id=%2Fsites%2Fgmedochub27%2FShared%20Documents%2Fgmedochub%2FTraning%2FGME%5FDochub%5FAccerss%5Fuser%5Fguide3%2E0%5Ffinal%2Epdf&parent=%2Fsites%2Fgmedochub27%2FShared%20Documents%2Fgmedochub%2FTraning"
      className="text-brand-primary"
    >
      Click here.
    </a>
  </p>
  <p style={{ marginTop: "0.5rem" }}>
    Raise IT tickets for technical issues –{" "}
    <a
      target="_blank"
      href="https://eur03.safelinks.protection.outlook.com/?url=https%3A%2F%2Fmyit.bpglobal.com%2Fmyit%3Fid%3Dmyit_ticket_submission_form"
      className="text-brand-primary"
    >
      MyIT.
    </a>
  </p>
  <p>
    Send delivery and tax related documents to{" "}
    <a
      className="text-brand-primary"
      href="mailto:synergydrn@uk.bp.com"
    >
      synergydrn@uk.bp.com
    </a>{" "}
    mailbox.
  </p>
  <p>
    Contact GME Document Hub Team at{" "}
    <a
      className="text-brand-primary"
      href="mailto:gmedochubsupport@castrol.com"
    >
      gmedochubsupport@castrol.com
    </a>.
  </p>
</div>
        </div>
      </div>
    </UnauthenticatedTemplate>
    </div>
  );
};

export default Login;
